import React from 'react';
import { MapPin } from 'lucide-react';
export function NorthvilleDistance() {
  return <section className="bg-charcoal text-white py-6" data-id="element-2597">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-3" data-id="element-2598">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-2599" />
        <span className="text-lg font-bold uppercase tracking-wide" data-id="element-2600">
          Conveniently located near Northville
        </span>
      </div>
    </section>;
}